export var RequestError = /*#__PURE__*/ function(RequestError) {
    RequestError[RequestError["UserNotFound"] = 0] = "UserNotFound";
    RequestError[RequestError["FriendLimitReached"] = 1] = "FriendLimitReached";
    RequestError[RequestError["GeneralError"] = 2] = "GeneralError";
    return RequestError;
}({});

//# sourceMappingURL=types.js.map